module.exports = __webpack_public_path__ + "static/media/random-bg.c423acd5.png";